// extracted by mini-css-extract-plugin
export var active = "_1d-7";
export var container = "_1d-0";
export var evenWidth = "_1d-4";
export var large = "_1d-5";
export var outlet = "_1d-8";
export var slide = "_1d-2";
export var small = "_1d-6";
export var tab = "_1d-3";
export var tabs = "_1d-1";